// extracted by mini-css-extract-plugin
export default {"space90":"index_space90_nMe46","footcolumn":"index_footcolumn_vbcUO"};